<ac-form *ngIf="dialogConfig.ready"
         [allowNullProperties]="allowNullProperties"
         [auxiliaryModel]="additionalSettings"
         [formModel]="rule"
         [formSchema]="schema"
         [isEdit]="isEdit"
         [isViewMode]="viewOnly"
         [requiredsAuxiliaryForm]="requiredsAuxiliaryForm"
         [validateAuxiliaryForm]="validateAuxiliaryForm"
         formModelName="rule">

    <div class="flexColumnParent" id="forwarding-rule-dialog-content">
        <div class="forwarding-rule-general-details flexItem">

            <ac-input-container formFieldName="rule.name" label="Rule Name" [sideMargin]="false">
                <ac-textfield [(acModel)]="rule.name"
                              [ngDisabled]="isEdit"
                              id="forwarding-rule-general-details-rule-name">
                </ac-textfield>
            </ac-input-container>

            <ac-radio-buttons-group *ngIf="rule.ruleType === ALARM_EVENT_TYPE"
                                    [(acModel)]="rule.forwardType"
                                    (acModelChange)="ruleForwardTypeChanged()"
                                    [items]="forwardingType.options"
                                    class="vertical"
                                    radioButtonId="radio-button-fwd-type">
            </ac-radio-buttons-group>


            <ac-checkbox labelText="Enable/Disable Rule" [(acModel)]="rule.ruleEnabled" checkboxId="rule-enabled" [sideMargin]="false"></ac-checkbox>
        </div>

        <ac-tabs class="flexItemBiggest" tabsId="fwd-rule-tab-set">
            <forwarding-topology-tab *acTab="'Topology Conditions'; id:'fwd-rule-topology-tab'; if: rule && additionalSettings.ruleType === ALARM_EVENT_TYPE"
                                     [additionalSettings]="additionalSettings"
                                     [externalApps]="externalApps"
                                     [emptyRule]="emptyRule"
                                     [isEdit]="isEdit"
                                     [rule]="rule"
                                     [tenantsOptions]="tenantsOptions"
                                     [viewOnly]="viewOnly">
            </forwarding-topology-tab>

            <forwarding-rule-conditions-tab *acTab="'Rule Conditions'; id:'fwd-rule-conditions-tab'; if: rule"
                                            [additionalSettings]="additionalSettings"
                                            [isEdit]="isEdit"
                                            [rule]="rule">
            </forwarding-rule-conditions-tab>

            <forwarding-destination-tab *acTab="'Destination'; id:'fwd-rule-destination-tab'"
                                        [additionalSettings]="additionalSettings"
                                        [emptyRule]="emptyRule"
                                        [isEdit]="isEdit"
                                        [rule]="rule"
                                        [tenantOperatorsOptions]="tenantOperatorsOptions">
            </forwarding-destination-tab>


            <forwarding-active-time-tab *acTab="'Active Time'; id:'fwd-rule-active-time-tab';"
                                        [additionalSettings]="additionalSettings"
                                        [emptyRule]="emptyRule"
                                        [isEdit]="isEdit"
                                        [rule]="rule"
                                        [tenantOperatorsOptions]="tenantOperatorsOptions">
            </forwarding-active-time-tab>
        </ac-tabs>
    </div>
</ac-form>
